import { render, staticRenderFns } from "./DAPrimaryButton.vue?vue&type=template&id=41bbd1b8"
import script from "./DAPrimaryButton.vue?vue&type=script&lang=js"
export * from "./DAPrimaryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports